const actionTypeIdentifier = "9E7BC5F4-1E3A-4C20-9761-CB782F9E77F0";

export const setDebitorHistoryLogsLoading = `SET-DEBITOR-HISTORY-LOGS-LOADING-${actionTypeIdentifier}`;
export const getDebitorHistoryLogs = `GET-DEBITOR-HISTORY-LOGS-${actionTypeIdentifier}`;
export const setDebitorHistoryPageSize = `SET-DEBITOR-HISTORY-PAGE-SIZE-${actionTypeIdentifier}`;
export const resetDebitorHistory = `RESET-DEBITOR-HISTORY-${actionTypeIdentifier}`;
export const setDebitorHistoryColSearchStr = `SET-DEBITOR-HISTORY-COL-SEARCH-${actionTypeIdentifier}`;
